import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import communicationHistoryStyles from '../CommunicationHistory/index.module.scss';
import Tabs from '@components/Tabs';
import TabItem from '@navi/web-ui/lib/components/Tabs/TabItem';
import { COMMUNICATION_TAB_KEYS, COMMUNICATION_TABS } from '../../constants';
import Carousel from '../../../../components/Carousel/Carousel';
import LanGroup from './LanGroup';
import { createQueryParams, readQueryParams } from '../../../../utils/QueryParamsHelper';
import { NUMBER_OF_ELEMENTS, PREVIOUS_LOAN_ACCOUNT_INTERACTIONS } from './constants';
import { QueryParams } from '../../../../components/interfaces';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { createKey } from '../../../../utils/CaseDetail.utils';
import styles from './PreviousLoanCommunicationHistory.module.scss';
import { GLOBAL } from 'src/constants/Global';
import cx from 'classnames';

const PreviousLoanCommunicationHistory = () => {
  const { loanId = '', customerId = '' } = useParams();
  const navigate = useNavigate();
  const { [PREVIOUS_LOAN_ACCOUNT_INTERACTIONS]: queryParams, ...rest } = readQueryParams();
  const previousLANCommuncationTabs = COMMUNICATION_TABS?.filter(
    tab => tab.key !== COMMUNICATION_TAB_KEYS.NAVI_WHATSAPP
  );
  const closedLoanAccountViews = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.details?.data
        ?.closedLoanAccountViews || []
  );

  const getCarouselArrowVisibility = () => {
    return GLOBAL.SCREEN_WIDTH < 1400
      ? closedLoanAccountViews?.length > NUMBER_OF_ELEMENTS.TWO
      : closedLoanAccountViews?.length > NUMBER_OF_ELEMENTS.THREE;
  };

  const updateQueryParamsAndNavigate = (params?: QueryParams, lastUsed?: string) => {
    const url = createQueryParams({
      [PREVIOUS_LOAN_ACCOUNT_INTERACTIONS]: { ...queryParams, ...params, lastUsed },
      ...rest
    });
    navigate(url, {
      replace: true
    });
  };

  useEffect(() => {
    if (closedLoanAccountViews?.length) {
      updateQueryParamsAndNavigate({
        previousLoanAccount:
          queryParams?.previousLoanAccount || closedLoanAccountViews[0]?.accountNumber,
        previousCaseReferenceId:
          queryParams?.previousCaseReferenceId || closedLoanAccountViews[0]?.caseReferenceId
      });
    }
  }, [closedLoanAccountViews]);

  const onChipSelect = (lanValue: string, caseReferenceId: string) => {
    updateQueryParamsAndNavigate({
      previousLoanAccount: lanValue,
      previousCaseReferenceId: caseReferenceId
    });
  };

  const isPaused = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.pause?.data?.isPaused
  );

  return (
    <div className={cx('tabContentScroll', { tabContentScrollWithPausedCase: isPaused })}>
      {closedLoanAccountViews?.length ? (
        <>
          <div>
            <Carousel
              buttonWrapperVisibilityClass={
                getCarouselArrowVisibility() ? styles.buttonVisible : styles.buttonHidden
              }
              slidesWrapperClassName={styles.slidesWrapperClass}
              carouselWrapperClass={styles.carouselWrapperClass}
              carouselSlideClass={styles.carouselSlideClass}
            >
              {closedLoanAccountViews?.map((lan, index) => (
                <LanGroup
                  key={index}
                  lan={lan}
                  onChipSelect={onChipSelect}
                  selectedLAN={queryParams?.previousLoanAccount || ''}
                />
              ))}
            </Carousel>
          </div>
          <div className={communicationHistoryStyles.tabContainer}>
            <Tabs
              tabsClassName={communicationHistoryStyles.tabClass}
              orientation="vertical"
              variant="pill"
              contentClassName={communicationHistoryStyles.tabContent}
              containerClassName={communicationHistoryStyles.containerClass}
              defaultSelectedKey={COMMUNICATION_TAB_KEYS.CALLS}
            >
              {previousLANCommuncationTabs.map(tab => (
                <TabItem key={tab.key} label={tab.value}>
                  {tab.component}
                </TabItem>
              ))}
            </Tabs>
          </div>
        </>
      ) : (
        <div className={styles.previousLanNotExist}>
          No previous LANs existing for this customer
        </div>
      )}
    </div>
  );
};

export default PreviousLoanCommunicationHistory;
